import React from "react";
import { Box, CssBaseline } from "@mui/material";
import { ThemeProvider, createTheme, alpha } from "@mui/material/styles";
import { Navbar } from "./Components/Navbar";
import { HeroSection } from "./Components/HeroSection";
import { FeaturesSection } from "./Components/FeaturesSection";
import { Footer } from "./Components/Footer";

// Tema Azul/Rosa Suave, delicado e acolhedor
const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#81D4FA", // Azul Claro
      dark: "#4FC3F7",
      light: "#B3E5FC",
      contrastText: "#01579B",
    },
    secondary: {
      main: "#F48FB1", // Rosa Claro
      dark: "#F06292",
      light: "#F8BBD0",
      contrastText: "#880E4F",
    },
    background: {
      default: "#FCE4EC", // Rosa bem claro
      paper: "#FFFFFF",
    },
    text: {
      primary: "#37474F", // Cinza Azulado
      secondary: "#546E7A",
    },
    divider: alpha("#546E7A", 0.15),
  },
  typography: {
    fontFamily: '"Quicksand", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 600,
    },
    h2: {
      fontWeight: 600,
    },
    h3: {
      fontWeight: 500,
    },
    button: {
      textTransform: "none",
      fontWeight: 700,
    },
  },
  shape: {
    borderRadius: 16, // Bordas mais arredondadas
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 30,
          padding: "10px 25px",
          boxShadow: "none",
        },
        containedPrimary: {
          color: "#01579B",
          "&:hover": {
            backgroundColor: "#4FC3F7",
            boxShadow: `0 4px 15px ${alpha("#81D4FA", 0.3)}`,
          },
        },
        containedSecondary: {
          color: "#880E4F",
          "&:hover": {
            backgroundColor: "#F06292",
            boxShadow: `0 4px 15px ${alpha("#F48FB1", 0.3)}`,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: `0 2px 10px ${alpha("#B0BEC5", 0.1)}`,
          border: "1px solid transparent",
          transition: "border-color 0.3s ease, box-shadow 0.3s ease",
          "&:hover": {
            borderColor: alpha("#F8BBD0", 0.5),
            boxShadow: `0 6px 18px ${alpha("#B0BEC5", 0.15)}`,
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontWeight: 500,
          color: "#546E7A",
        },
      },
    },
  },
});

export const LandingPages0007 = () => {
  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          backgroundColor: theme.palette.background.default,
        }}
      >
        <CssBaseline />
        <Navbar />
        <HeroSection />
        <FeaturesSection />
        <Footer />
      </Box>
    </ThemeProvider>
  );
};
